// El «rumbo» de cada resultado: a qué servicio apunta la aguja y qué hitos de la charla se muestran.
// No agrega datos: todo sale de `node.servicio` y de los dataKey que la charla ya recolecta.
// 🟠 Los nombres de los cinco puntos y los rótulos de los hitos son provisorios hasta que An los defina.

export const PUNTOS = ['Web', 'IA', 'Equipo', 'Orden', 'Otra'];

const PUNTO_DE = {
  'Web': 0,
  'Web (ya tiene)': 0,
  'Implementar IA': 1,
  'Capacitación en IA': 2,
  'Ordenar la operación': 3,
  'Otra situación': 4,
};

// La frase de cada resultado: se comparte el resultado de la persona, no GUIA. Una frase por punto de la rosa.
// Verificadas el 24/10/2026 (fuentes en el PR). Traducciones libres de GUIA; el original queda en `original`.
// 🟠 Decisión de An: la elección de cada frase y su traducción.
export const FRASES = [
  { texto: 'Esto es para todos.', autor: 'Tim Berners-Lee', rol: 'Creador de la World Wide Web', original: 'This is for everyone.' },
  { texto: 'Solo vemos un poco más allá, pero ahí ya hay mucho por hacer.', autor: 'Alan Turing', rol: 'Pionero de la computación', original: 'We can only see a short distance ahead, but we can see plenty there that needs to be done.' },
  { texto: 'Solos podemos poco; juntos, tanto.', autor: 'Helen Keller', rol: 'Escritora y activista', original: 'Alone we can do so little; together we can do so much.' },
  { texto: 'Lo simple puede ser más difícil que lo complejo: hay que trabajar mucho para dejar el pensamiento limpio y lograr que sea simple.', autor: 'Steve Jobs', rol: 'Cofundador de Apple', original: 'Simple can be harder than complex: you have to work hard to get your thinking clean to make it simple.' },
  { texto: 'La mejor manera de predecir el futuro es inventarlo.', autor: 'Alan Kay', rol: 'Pionero de la informática personal', original: 'The best way to predict the future is to invent it.' },
];

export const puntoDe = (servicio) => PUNTO_DE[servicio] ?? 4;
export const nombreDe = (servicio) => (servicio === 'Web (ya tiene)' ? 'Web' : servicio || 'Otra situación');

const texto = (v) => (typeof v === 'string' ? v.trim() : '');
export const corto = (t, n = 64) => (t.length > n ? `${t.slice(0, n - 1).trimEnd()}…` : t);

// `propio: true` = lo escribió la persona con sus palabras. Se muestra en su pantalla, pero NO va a la tarjeta
// para compartir (puede tener nombres o datos de su negocio).
export const hitos = (c = {}) => [
  ['rol', 'Rol', texto(c.rol), false],
  ['negocio', 'Tu negocio', texto(c.businessName) || texto(c.businessInfo) || texto(c.idea), true],
  ['pesa', 'Lo que más pesa', texto(c.iaTarea) || texto(c.operacion) || texto(c.freeformNeed), true],
  ['equipo', 'Equipo', texto(c.equipo) || texto(c.alcanceTaller), false],
  ['llevas', 'Cómo lo llevás', texto(c.comoLoLleva), false],
  ['busqueda', 'Cómo te encuentran', texto(c.howFound), false],
  ['google', 'En Google', texto(c.searchability), false],
]
  .filter(([, , valor]) => valor)
  .map(([id, etiqueta, valor, propio]) => ({ id, etiqueta, valor: corto(valor), propio }));

